import {DropdownSelectData} from "app/Interface/Component/Form"
import ApiSystemLayoutGridItemService from "app/Service/Api/System/ApiSystemLayoutGridItemService"
import UserService from "app/Service/ClientUser/UserService"
import SystemLayoutService, {SubscribeSystemLayout} from "app/Service/System/Layout/SystemLayoutService"
import SystemLayoutUiService, {SubscribeSystemLayoutUiService} from "app/Service/System/Layout/SystemLayoutUiService"
import SystemModuleService, {subscribeSystemModule} from "app/Service/System/Module/SystemModuleService"
import SystemWidgetService, {subscribeSystemWidget} from "app/Service/System/SystemWidgetService"
import InputSelect from "app/WebController/Component/Form/InputSelect"
import React, {useEffect, useState} from "react"
import {useTranslation} from "react-i18next"


const AddGridItemButton = () => {

  const {t} = useTranslation('Toolbar.Layout')

  const {hasRole} = UserService([], 'AddGridItemButton')

  const {putGridItem} = ApiSystemLayoutGridItemService('AddGridItemButton')

  const {systemLayoutActive} = SystemLayoutService([
    SubscribeSystemLayout.active
  ], 'AddGridItemButton')

  const {activeTabId, breakpoint, forceBreakpoint} = SystemLayoutUiService([
    SubscribeSystemLayoutUiService.activeTabId,
    SubscribeSystemLayoutUiService.breakpoint,
    SubscribeSystemLayoutUiService.forceBreakpoint,
  ], 'AddGridItemButton')

  const {activeSystemModule} = SystemModuleService([
    subscribeSystemModule.activeSystemModule
  ], 'AddGridItemButton')

  const {systemWidgets} = SystemWidgetService([
    subscribeSystemWidget.systemWidgets
  ], 'AddGridItemButton')

  const [widgetsToAdd, handleWidgetsToAdd] = useState<DropdownSelectData[]>([])

  useEffect(() => {
    if (!systemLayoutActive || !activeSystemModule) return

    const widgetOptions: DropdownSelectData[] = []
    systemWidgets.map(w => {

      if (w.module === activeSystemModule.id
        && w.crudOperator === systemLayoutActive.crudOperator
        && (null === w.permission || hasRole(w.permission))
      ) {
        widgetOptions.push({
          active: false,
          id: w.id,
          name: t(w.name, {ns: `ContentGridWidgets.LayoutAddWidgetTitle`})
        })
      }
    })

    handleWidgetsToAdd(widgetOptions.sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0))
  }, [activeSystemModule, systemLayoutActive, systemWidgets])

  async function addWidgetToLayout(selectedWidget: DropdownSelectData | undefined) {
    if (undefined === selectedWidget) return
    if (undefined === activeTabId) return
    if (!systemLayoutActive || !breakpoint) return

    await putGridItem({
      widgetId: selectedWidget.id,
      tabId: activeTabId,
      layoutId: systemLayoutActive.id,
      breakpoint: forceBreakpoint ?? breakpoint
    })
  }

  return (
    <InputSelect
      id={'add-grid-item'}
      onChange={o => addWidgetToLayout(o as DropdownSelectData)}
      options={widgetsToAdd}
      canOpenFn={true}
      showSearch={true}
      allowAdd={false}
      onOpenCbFn={undefined}
      title={t('addWidgetTitle')}
    />
  )
}

export default AddGridItemButton
